import './App.css';
import { Rutas } from './routing/rutas';

function App() {
  return (
    <div>
        <Rutas />
    </div>
  );
}

export default App;
